import {decodeHtmlEntities as decode} from '@web/helpers/htmlEntities'
import {AddressInfo} from '@web/slices/deliveryInfo/slice'

import {DeliveryAddress} from '../apis/interfaces'

export const convertDeliveryAddress = (addressInfo?: Maybe<DeliveryAddress>): Maybe<AddressInfo> => {
    if (!addressInfo) {
        return null
    }

    return {
        hash: addressInfo.addressId,
        addressName: decode(addressInfo.addressName),
        baseAddress: decode(addressInfo.baseAddress),
        detailAddress: decode(addressInfo.detailAddress ?? ''),
        zipCode: addressInfo.zipCode,
        buildingManagementNo: addressInfo.buildingManagementNo,
        locationX: addressInfo.locationX,
        locationY: addressInfo.locationY,
        receiverName: decode(addressInfo.receiverName),
        telNo1: addressInfo.telNo1,
        telNo2: addressInfo.telNo2,
        isPrimaryAddress: addressInfo.primary,
        isRegistered: addressInfo.registered ?? false,
        isRoadNameAddress: addressInfo.road,
        locationType: addressInfo.pickupLocationType,
        locationDescription: addressInfo.pickupLocationContent,
        entryMethodType: addressInfo.entryMethodType,
        entryDescription: addressInfo.entryMethodContent,
    }
}
